import { withVersions } from "v2/hocs/withVersions";
import { BaseButton } from "v2/components/base/Button/ui";

const BasicButton = withVersions({
  v1: BaseButton,
  v2: BaseButton,
});

export default BasicButton;
